import styles from "./taskdetails.module.css";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import { Check, ChevronRight, Star, User } from "react-feather";
import TaskForm from "../TechnicianTasks/components/TaskForm";

const formatName = (name) => {
  if (!name) return "";

  const parts = name.trim().split(" ");

  if (parts.length === 1) {
    return parts[0];
  }

  return parts[0] + " " + parts.slice(1).map((part) => part.charAt(0).toUpperCase() + ".").join(" ");
}


const TaskCheckList = ({ taskCheckList, setTaskCheckList, onCheckList, saveAnswer, taskDetails }) => {
  const { user, isAuthenticated } = useAuth0();
  const [taskExpanded, setTaskExpanded] = useState("");
  const [activeItem, setActiveItem] = useState(null);

  const handleChange = (panel) => (event, isTaskExpanded) => {
    setTaskExpanded(isTaskExpanded ? panel : false);
  }

  const saveAnswerLocal = (data, task, date) => {
    const updatedList = taskCheckList.map((day) => day.date === date ? { ...day, tasks: day.tasks.map((t) => t.id === task?.id ? { ...t, is_checked: 1 } : t) } : day);
    setTaskCheckList(updatedList);

    saveAnswer(data, task);
  }

  if (!taskCheckList || taskCheckList.length === 0) {
    return <div className={`${styles.NoDataMain}`}>
      <div className={`${styles.NoDataIMG}`}>
        <img src="/static/img/tasklist.svg" alt="" />
      </div>
      <p className={`${styles.NoDataText}`}>Woohoo!</p>
      <p className={`${styles.NoDataTextSub}`}>There are no checklist available.</p>
    </div>;
  }

  return (<>
    {taskCheckList.map((day, index) => {
      const completedCount = day.tasks.filter((t) => t.is_checked).length;
      const totalCount = day.tasks.length;

      return (<Accordion key={day.date} expanded={taskExpanded === `panel-${index}`} onChange={handleChange(`panel-${index}`)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel-${index}-content`} id={`panel-${index}-header`}>
          <div className={styles.FormAccoHead}>
            <p className={styles.FormAccoHeadTitle}>
              <span>Task Date</span> {dayjs(day.date).format("MM/DD/YYYY")}
            </p>
            <p className={styles.FormAccoHeadSubTitle}>
              <span>Completed Tasks</span>
              {completedCount}/{totalCount}
              {completedCount < totalCount && (<img src="/static/img/warning.png" alt="warning" />)}
              {completedCount === totalCount && (<img src="/static/img/success.png" alt="Completed" />)}
            </p>
            <p className={`${styles.FormAccoHeadSubTitle} ${styles.Technician}`}>
              <span>Technicians:</span>
              <div className={`${styles.TechChips}`}>
                <span className={`${styles.TechChip}`}><User /> {formatName(taskDetails?.technician_name)} <Star className={`${styles.Primary}`} /></span>
                {taskDetails?.secondary_technician > 0 && <span className={`${styles.TechChip}`}><User /> {formatName(taskDetails?.secondary_technician_name)}</span>}
              </div>
            </p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={styles.CussAccoRow}>
          <div className={styles.TaskCheckSec}>
            {/*day.tasks.map((task) => (<div key={task.id} className={styles.TaskCheckList}>
              <FormControlLabel
                className={styles.ProsCheckSec} control={<Checkbox
                  checked={!!task.is_checked}
                  onChange={() => handleCheckToggle(day.date, task.id, task.is_checked)}
                />}
                label={task.is_checked ? (<del>{task.task_list}</del>) : (task.task_list)}
              />
            </div>))*/}

            {day.tasks.map((task, index) => (<>
              <div key={task.id} className={activeItem === index ? `${styles.TaskCheckList} ${styles.Active}` : `${styles.TaskCheckList}`}>
                <div className={`${styles.TaskCheckListHead}`} onClick={() => {
                  console.log(task.task_is_question);
                  if (task.task_is_question === 0)
                    return false;
                  setActiveItem((prev) => (prev === index ? null : index));
                }}>
                  <FormControlLabel
                    className={`${styles.ProsCheckSec}`}
                    control={<Checkbox
                      checked={!!task.is_checked}
                      disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task-checklist:update") > -1)}
                    />}
                  />
                  <div className={`${styles.TaskTitleSec}`}>
                    <p>{task.is_checked ? (<del>{task.task_list}</del>) : (task.task_list)}</p>
                    {task.is_checked === 1 ? <>
                      <div className={`${styles.TaskPreview}`}>
                        <span className={`${styles.TechChip}`}><User /> {task?.checked_by > 0 ? formatName(task?.checked_by_name) : formatName(task?.technician_name)} {task?.checked_by > 0 ? task?.technician === task?.checked_by && <Star className={`${styles.Primary}`} /> : <Star className={`${styles.Primary}`} />}</span>
                        {task?.task_is_question === 1 && <>
                          <span className={`${styles.StatusBadgeANS}`}><Check /> Answered</span>
                          <span className={`${styles.StatusAnsText}`}>View answer</span>
                        </>}
                      </div>
                      {task?.task_is_question === 1 && <ChevronRight className={`${styles.TaskDeIcon}`} />}
                    </> : <>
                      <div className={`${styles.TaskPreview}`}>
                        <span className={`${styles.TechChip}`}><User /> {task?.checked_by > 0 ? formatName(task?.checked_by_name) : formatName(task?.technician_name)} {task?.checked_by > 0 ? task?.technician === task?.checked_by && <Star className={`${styles.Primary}`} /> : <Star className={`${styles.Primary}`} />}</span>
                        {task?.task_is_question === 1 && <>
                          <span className={`${styles.StatusBadge}`}>Question</span>
                          <span className={`${styles.StatusAnsText}`}>Tap to answer</span>
                        </>}
                      </div>
                      {task?.task_is_question === 1 && <ChevronRight className={`${styles.TaskDeIcon}`} />}
                    </>}
                  </div>
                </div>

                <div className={`${styles.TaskAnsSec}`}>
                  <TaskForm task={task} saveAnswerConf={saveAnswerLocal.bind(this)} date={day.date} />
                </div>

              </div>
            </>))}
          </div>
        </AccordionDetails>
      </Accordion>);
    })}
  </>);
};

export default TaskCheckList;